import { Link } from 'react-router-dom';
import { EmptyState } from './EmptyState';

export function NotFound({ what, to, label }: { what: string; to: string; label: string }) {
  return (
    <EmptyState
      title={`${what} not found`}
      hint="It may have been removed, or the link is wrong."
      action={<Link to={to} className="md-action">← {label}</Link>}
    />
  );
}

export function LoadError({ what, to, label }: { what: string; to: string; label: string }) {
  return (
    <EmptyState
      tone="error"
      title={`Failed to load ${what}`}
      hint="Check your connection and try again."
      action={<>
        <button type="button" className="md-action" onClick={() => window.location.reload()}>Retry</button>{' '}
        <Link to={to} className="md-action">← {label}</Link>
      </>}
    />
  );
}
